import { atom } from 'jotai'

export const initialValue: string =
  navigator.cookieEnabled && sessionStorage.getItem('identityType')

export const identityTypeAtom = atom(initialValue)
